import { FunnelConfig } from '~/utils/funnels';

export const BUSINESS = 'business';

export const config: FunnelConfig = {
  id: BUSINESS,
  path: '/business',
  show: () => true,
};
